import {API } from "../../API_CONFIG";
export const BASE_URL = API;

export const dayNames = {
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
  0: "Sunday",
};

export const dayIndices = [0, 1, 2, 3, 4, 5, 6];

export const months = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];

export const doctorDegrees = [
"MBBS",
"M.D.",
"D.O.",
"D.D.S.",
"D.M.D.",
"D.P.M.",
"D.V.M.",
"V.M.D.",
"Pharm.D.",
"D.P.T.",
"D.N.P.",
"Dr.P.H.",
"Psy.D.",
"Ph.D.",
"D.H.Sc.",
"O.T.D.",
"S.L.P.D.",
];

export const categories = [
  "Cardiology",
  "Dental",
  "Dermatology",
  "Endocrinology",
  "ENT",
  "Gastroenterology",
  "General Medicine",
  "General Surgery",
  "Health Science",
  "Infertility Medicine",
  "Medical/Physician",
  "Nephrology",
  "Neurology",
  "Nursing",
  "Obstetrics & Gynaecology",
  "Occupational Therapy",
  "Oncology",
  "Ophthalmology",
  "Orthopaedics",
  "Paediatrics",
  "Pharmacy",
  "Physical Therapy",
  "Plastic Surgery / Cosmetic Surgery",
  "Podiatry",
  "Psychiatry",
  "Psychology",
  "Public Health",
  "Pulmonology",
  "Research/Medical Science",
  "Rheumatology",
  "Speech-Language Pathology",
  "Urology",
  "Veterinary"
];

export const StateArray = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Jammu and Kashmir",
];

export const govermentIdArray = ["Aadhar Card", "Pan Card", "Passport", "Driver's License", "Other"];

export const profileStatus = ["Active", "Inactive"];

export const QCStatus = ["Passed", "Failed", "Error", "InProgress", "Draft"];

export const specialties = [
  "General Physician",
  "Pediatrics",
  "Dentist",
  "Dermatology",
  "Gynecology",
  "General Surgeon",
  "Gastroenterology",
  "Orthopaedician",
  "ENT",
  "Neurology",
  "Psychiatry",
  "Psychology",
  "Cardiologist",
  "Ophthalmology",
  "Pulmonologist",
  "Nephrology",
  "Physiotherapist",
  "Oncology",
  "Infertility",
  "Dietician",
  "Urologist",
  "Endocrinologist",
  "Haematologist",
  "Rheumatologist",
  "Geriatrician",
  "Sexology",
];


export const Services = [
  "Inclinic",
  "Labs",
];


export const routerLink = {
  'profilePage': `/offlineConsults/DoctorManagements`,
  'schedule': `/offlineConsults/DoctorManagements/Schedule`,
  'holidays': `/offlineConsults/DoctorManagements/Holidays`,
};

export const doctorListURL = '/offlineConsults/DoctorManagement';

export const allowedExtension = ['jpg', 'jpeg', 'png', 'JPEG', 'PNG', 'JPG'];

export const SOME_THING_WENT_WRONG = 'Something went wrong. Please try again later';
export const DOCTOR_PROFILE_SAVED_SUCCESS = "Doctor Profile Saved Successfully"

export const DURATION_ARRAY = ['duration1', 'duration2', 'duration3'];


export const DAYS = [
  { key: "sunday", label: "S" },
  { key: "monday", label: "M" },
  { key: "tuesday", label: "T" },
  { key: "wednesday", label: "W" },
  { key: "thursday", label: "T" },
  { key: "friday", label: "F" },
  { key: "saturday", label: "S" },

];

export const DAYS_TO_INDEX = {
  "Sunday": 0,
  "Monday": 1,
  "Tuesday": 2,
  "Wednesday": 3,
  "Thursday": 4,
  "Friday": 5,
  "Saturday": 6
};


export const EXCEED_SIZE_LIMIT = "Exceeded the file size limit of 2MB";

export const getFileUsingGUID = 'https://www.medibuddy.in/WAPI//GetFile'

export const breadcrumbNameMap = {
  "/offlineConsults/DoctorManagements": 'Doctor Profile',
  '/offlineConsults/DoctorManagements/Schedule': 'Schedule',
  '/offlineConsults/DoctorManagements/Holidays': 'Holidays',
};

export const SPOC_breadcrumbNameMap = {
  "/SPOC/DoctorManagements": 'SPOC Profile',
};

export const PROVIDERNODE_BASE_URL = BASE_URL.providerNode;
export const WAPI_BASE_URL = BASE_URL.WAPI;
export const videoUrl = "https://views.medibuddy.in/provider-central-english.mp4";
export const videoUrlDoctorManagement = "https://views.medibuddy.in/Doctor_Management_Provider_Central.mp4";
export const FILE_PATH_PROFILE_IMAGE =BASE_URL.s3_doctor_images_bucket;
export const VIEWS_MEDIBUDDY_URL = "https://views.medibuddy.in"


export const profileStatusColor = {
  orange :{
    pathColor:'#F27400',
    textColor:'#FCD9B8',
    trailColor: '#FFF5ED',
  },
  yellow :{
    pathColor:'#CD8B08',
    textColor:'#FCDE64',
    trailColor: '#FFF7CE',
  },
  green: {
    pathColor:'#51A87F',
    textColor:'#CCE5D9',
    trailColor: '#F1F8F5',
  }
}

export const PROFILE_PECENTAGE = {
  0: 0,
  64: 64,
  85: 85,
  100: 100  
}


export const SLOTS_DAY_CONSTANT = [
  {
    key: "Sunday",
    label: "S",
    index: 0
  },
  {
    key: "Monday",
    label: "M",
    index: 1
  },
  {
    key: "Tuesday",
    label: "T",
    index: 2
  },
  {
    key: "Wednesday",
    label: "W",
    index: 3,
  },
  {
    key: "Thursday",
    label: "T",
    index: 4,
  },
  {
    key: "Friday",
    label: "F",
    index: 5,
  },
  {
    key: "Saturday",
    label: "S",
    index: 6,
  },

];

export const FEATURE_NAME = {
  CREATE_DOCTOR:'UPDATE_DOCTOR',
  UPDATE_DOCTOR_STATUS:'UPDATE_DOCTOR_STATUS',
  UPDATE_DOCTOR:'UPDATE_DOCTOR',
  UPDATE_HOLIDAY:'UPDATE_DOCTOR',
  UPDATE_SLOTS:'UPDATE_DOCTOR',
  SPOC_LIST:'VIEW_SPOC_LIST',
  SPOC_DETAILS:'VIEW_SPOC_DETAILS',
  SPOC_STATUS_UPDATE:'UPDATE_SPOC_STATUS',
  VIEW_OFFLINE:'VIEW_OFFLINE',
  VIEW_LABS:"VIEW_LABS",
  CREATE_SPOC:'CREATE_SPOC',
  UPDATE_SPOC:'EDIT_SPOC_DETAILS',
  UPDATE_SPOC_STATUS:'UPDATE_SPOC_STATUS',
  RESET_PASSWORD:'RESET_PASSWORD',
}

export const NUMBER_ONLY_REGEX = /^[0-9]*$/;
